import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

/**
 * Layout route for the roles section.
 *
 * It renders an `Outlet` and nothing else. Its only job is to hold the
 * `role.view` guard once, for the list at `/roles` and the editor at
 * `/roles/$roleId` alike, so neither child can be reached without it.
 *
 * The guard is presentation only. The API enforces `role.view` on every roles
 * endpoint, so a stale grant still gets a 403 from the server; this only keeps
 * a user without the grant out of a screen they cannot use.
 *
 * Per the route-shell rule in `apps/company/AGENTS.md`, this file is a route
 * definition, a guard, and a render. Everything else lives in
 * `src/features/roles/`.
 */
export const Route = createFileRoute('/_authenticated/roles')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'role.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: Outlet,
})
